import { createSelector } from 'reselect';
import * as R from 'ramda';

const domain = ({ binotel }) => binotel;

export const getShow = createSelector(domain, ({ isShow }) => isShow);
export const getInitialized = createSelector(domain, R.prop('isInitialized'));
